// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    title: 'home',
    path: '/dashboard/app',
    icon: icon('ic_analytics'),
  },
  {
    title: 'directory',
    path: '/dashboard/products',
    icon: icon('ic_cart'),
  },
  {
    title: 'marketplace',
    path: '/dashboard/marketplace',
    icon: icon('ic_user'),
  },
  {
    title: 'tracker',
    path: '/dashboard/tracker',
    icon: icon('ic_user'),
  },
  {
    title: 'inbox',
    path: '/dashboard/inbox',
    icon: icon('ic_user'),
  },

  {
    title: 'explore',
    path: '/dashboard/explore',
    icon: icon('ic_blog'),
  },
  {
    title: 'feed',
    path: '/dashboard/blog',
    icon: icon('ic_blog'),
  },
  {
    title: 'profile',
    path: '/dashboard/profile',
    icon: icon('ic_lock'),
  }, 
];

export default navConfig;
